import React from 'react';
import { useTranslation } from '../../i18n/hooks/useTranslation';

export type IntegrationSource = 'xero' | 'myob' | 'quickbooks' | 'zohobooks' | null | undefined;

interface IntegrationSourceBadgeProps {
  source: IntegrationSource;
  /** If true, show as inline badge (default). If false, e.g. for page-level label. */
  inline?: boolean;
  className?: string;
}

const SOURCES_WITH_ICON: readonly NonNullable<IntegrationSource>[] = ['xero'];

export const IntegrationSourceBadge: React.FC<IntegrationSourceBadgeProps> = ({
  source,
  inline = true,
  className = ''
}) => {
  const { t } = useTranslation();

  const displaySource = source ?? null;
  const isManual = displaySource === null || displaySource === undefined;

  const label = isManual
    ? t('admin.integrationSource.manual')
    : t(`admin.integrationSource.${displaySource}`);

  const showIcon = !isManual && (SOURCES_WITH_ICON as readonly string[]).includes(displaySource);

  if (isManual) {
    return (
      <span className={`text-xs text-gray-500 dark:text-gray-400 ${className}`.trim()}>
        {label}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center text-xs text-accent-600 dark:text-accent-400 ${className}`.trim()}
      style={inline ? undefined : { display: 'inline-flex' }}
    >
      {showIcon && displaySource === 'xero' && (
        <img src="/xero.svg" alt="Xero" className="w-4 h-4 mr-1 flex-shrink-0" />
      )}
      {label}
    </span>
  );
};
